import {
  FullCatalog,
  OfflineReturns,
  ReverProtect,
  TrackingInterface,
  WarrantyManagement,
  Customization,
  ReverLogistics
} from '@/ui/components/rever-store/main-features/main-layouts'

import fullcatalog from '@/assets/images/rever-store/full-catalog.png'
import protect from '@/assets/images/rever-store/protect.png'
import tracking from '@/assets/images/rever-store/tracking.png'
import customization from '@/assets/images/rever-store/customization.png'
import warranty from '@/assets/images/rever-store/warranty.png'
import offline from '@/assets/images/rever-store/offline.png'
import logistics from '@/assets/images/rever-store/logistics.png'

import MainFeature from './main-feature'
import mainProducts from '@/ui/components/rever-store/store-data/mainProducts.json'
import { useEffect, useRef, useState } from 'react'

export const MainFeatures = () => {
  const products = [
    {
      image: fullcatalog,
      layout: FullCatalog
    },
    {
      image: protect,
      layout: ReverProtect
    },
    {
      image: tracking,
      layout: TrackingInterface
    },
    {
      image: offline,
      layout: OfflineReturns
    },
    {
      image: warranty,
      layout: WarrantyManagement
    },
    {
      image: customization,
      layout: Customization
    },
    {
      image: logistics,
      layout: ReverLogistics
    }
  ]
  const features = products.map((product, i) => {
    return {
      ...product,
      title: mainProducts[i].title,
      subtitle: mainProducts[i].subtitle,
      description: mainProducts[i].description,
      image: product.image
    }
  })
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(true)
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const handleScroll = () => {
    const container = scrollContainerRef.current
    if (!container) return
    setShowLeftArrow(container.scrollLeft > 0)
    setShowRightArrow(
      container.scrollLeft < container.scrollWidth - container.clientWidth
    )
  }
  const scrollAmount = 350
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      })
    }
  }

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      })
    }
  }
  useEffect(() => {
    const container = scrollContainerRef.current
    if (container) {
      container.addEventListener('scroll', handleScroll)
      handleScroll()
      return () => {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  return (
    <>
      <div className="relative w-full">
        {showLeftArrow && (
          <button
            className="absolute -left-10 top-1/2 z-50 size-16 translate-y-[-80%] rounded-full bg-gray-100 p-2 text-3xl font-thin text-gray-700 shadow-lg hover:bg-gray-300"
            onClick={scrollLeft}
          >
            ←
          </button>
        )}

        <div
          ref={scrollContainerRef}
          className="relative flex w-full overflow-x-scroll"
        >
          <div className="flex h-[340px] w-full gap-3">
            {features.map((Product, index) => (
              <MainFeature
                key={index}
                title={Product.title}
                subtitle={Product.subtitle}
                description={Product.description}
                image={Product.image}
                layout={<Product.layout />}
              />
            ))}
          </div>
        </div>

        {showRightArrow && (
          <button
            className="absolute -right-10 top-1/2 z-50 size-16 translate-y-[-80%] rounded-full bg-gray-100 p-2 text-3xl font-thin text-gray-700 shadow-lg hover:bg-gray-300"
            onClick={scrollRight}
          >
            →
          </button>
        )}
      </div>
    </>
  )
}
export default MainFeatures
